import type { QueryClient } from '@tanstack/react-query';
import type {
  AnyRouter,
  LinkProps,
  RegisteredRouter,
} from '@tanstack/react-router';
import { createRouter } from '@tanstack/react-router';
import { queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';

export interface RouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
});

export type LinkRoutes<TRouter extends AnyRouter = RegisteredRouter> =
  LinkProps<TRouter>['to'];

export type Routes<
  TRouter extends AnyRouter = RegisteredRouter,
  LinkRoutesType = LinkRoutes<TRouter>,
> = Exclude<LinkRoutesType, '.' | '..' | undefined>;

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
